"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SksgV2RebootCommandSerialization = void 0;
class SksgV2RebootCommandSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        return copy;
    }
}
exports.SksgV2RebootCommandSerialization = SksgV2RebootCommandSerialization;
